import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal, openModal } from '../reducers/modalReducer';

type UseErrorModalOptions = {
  title: string;
  userErrorMessage: string;
  details?: string;
};

export const useErrorModal = () => {
  const dispatch = useDispatch();

  const showErrorModal = useCallback(
    (error: unknown, options: UseErrorModalOptions) => {
      dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            httpError: error,
            okHandler: () => dispatch(closeModal()),
            technicalInfo: {
              title: options.title,
              userErrorMessage: options.userErrorMessage,
              details: options.details,
            },
          },
        }),
      );
    },
    [dispatch],
  );

  return { showErrorModal };
};
